/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Table from 'components/Table';
import {
  Row,
  Spin,
  Form,
} from 'antd';
import { checkToken } from 'api/utils';
import { onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';
import ModalFechaObservacion from 'components/ModalFechaObservacion';
import {
  getHistoricosComentariosDeEmpleados,
  postHistoricoComentarioDeEmpleado,
} from 'api/nominas/historicoComentariosEmpleado';
import { getModelPermission } from 'utils/permission';

export const historicoComentarioEmpleadoPermission = {
  permissionModel: 'historicocomentariosdeempleado',
  catalogsModels: [],
  tabsModels: [],
};

const ExpedienteComentarios = ({
  currentEmpleado,
}) => {
  const [data, setData] = useState([]);
  const [open, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getPermissions = getModelPermission(
    historicoComentarioEmpleadoPermission.permissionModel,
    historicoComentarioEmpleadoPermission.catalogsModels,
    historicoComentarioEmpleadoPermission.tabsModels,
    true,
  );

  const fetchData = async () => {
    setLoading(true);
    const _data = await getHistoricosComentariosDeEmpleados({ empleado: currentEmpleado });
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([
        getHistoricosComentariosDeEmpleados({ empleado: currentEmpleado }),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      values.empleado = currentEmpleado;
      const formattedDate = values.fecha_observacion.format('YYYY-MM-DD');
      values.fecha_observacion = formattedDate;
      // eslint-disable-next-line max-len
      const saved = await postHistoricoComentarioDeEmpleado(values);
      if (saved) {
        if (_continue) {
          await fetchData();
          form.resetFields();
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const columns = [
    {
      titleText: 'Fecha de Registro',
      dataIndex: 'fecha_observacion',
      key: 'fecha_observacion',
      width: 150,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 250,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          loading={loading}
          controls={{
            onClickAdd,
          }}
          allowExport
          allowExportPDF={false}
          permission={getPermissions}
        />
        <ModalFechaObservacion
          open={open}
          onCancel={onCancel}
          onPutDate={onFinish}
          title="Comentarios"
          subTitle="Registro"
          fechaKey="fecha_observacion"
          form={form}
          observacionRequerida
        />
      </Spin>
    </Row>
  );
};

export default ExpedienteComentarios;
